import React from 'react'
import { T } from '@transifex/react'
import { Icon, Text } from '@lightspeed/design-system-react'
import { Currency } from '@vend/business-components'

interface PaymentRequestInTransitWarningProps {
  /** Maximum amount (in dollars) that can be collected without touching in-transit funds */
  remainingAmount: number
  /** Total in-transit (ACH direct debit) amount in dollars */
  inTransitAmount: number
}

export const PaymentRequestInTransitWarning: React.FC<PaymentRequestInTransitWarningProps> = ({
  remainingAmount,
  inTransitAmount,
}) => {
  return (
    <div className="payment-request-overpayment-warning-banner">
      <Icon icon="fa-exclamation-triangle" />
      <Text style={{ lineHeight: '1.5' }}>
        <T
          _str="You cannot collect more than {remainingAmount} because a {inTransitAmount} ACH direct debit payment is currently in transit."
          _context="Payment request in-transit collection warning"
          remainingAmount={<Currency value={remainingAmount} />}
          inTransitAmount={<Currency value={inTransitAmount} />}
        />
      </Text>
    </div>
  )
}
